export default {
    label: 'Tu estado',
    label_screen_reader: 'Selecciona tu estado',
    label_native: 'Tu estado',
};
